import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, MenuItem } from '@mui/material';
import 'dayjs/locale/ko';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DateAdapter from '@mui/lab/AdapterDateFns';
import MobileSearchAdornment from '../common/search/MobileSearchAdornment';

export const CollectBuyListBox = ({ formik }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);

  useEffect(() => {
    if (formik.values.searchStrtDt) {
      setSearchStrtDt(dayjs(formik.values.searchStrtDt));
    }
    if (formik.values.searchEndDt) {
      setSearchEndDt(dayjs(formik.values.searchEndDt));
    }
  }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: { xs: 'contents', sm: 'flex' },
            flexDirection: 'row',
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
            alignItems: 'center',
            rowGap: 1,
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box
            sx={{
              order: { xs: 1, sm: 0 },
              flexBasis: { xs: '100%', sm: 'auto' },
              flex: { xs: '1 1 100%', sm: '0 1 auto' },
              minWidth: 0,
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: { xs: 0.5, sm: 1 }, width: { sm: '25ch' } },
              '& > :first-of-type': { flex: { xs: '0 0 38%', sm: '0 1 auto' } },
              '& > :last-of-type': { flex: { xs: 1, sm: '0 1 auto' } },
            }}
          >
            <TextField
              variant="standard"
              required
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              <MenuItem value="cstNm">사업명</MenuItem>
              <MenuItem value="partnerNm">고객명</MenuItem>
              <MenuItem value="invTxt">발급내용</MenuItem>
              <MenuItem value="invNo">계산서번호</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              required
              id="searchWords"
              name="searchWords"
              label="검색어"
              value={formik.values.searchWords}
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
              InputProps={{
                endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
              }}
            />
          </Box>
          <Box
            sx={{
              order: { xs: 2, sm: 0 },
              flexBasis: { xs: '100%', sm: 'auto' },
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              alignItems: 'center',
              gap: { xs: 0.5, sm: 0 },
            }}
          >
            <Box sx={{ flex: { xs: 1, sm: '0 1 auto' }, minWidth: 0, width: { sm: 'auto' } }}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker
                  label="검색 시작일"
                  format="YYYY-MM-DD"
                  mask={'____-__-__'}
                  id="searchStrtDt"
                  name="searchStrtDt"
                  value={dayjs(searchStrtDt)}
                  onChange={(newValue) => {
                    setSearchStrtDt(dayjs(newValue));
                    onChangeDate(dayjs(newValue), 'searchStrtDt');
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      fullWidth
                      error={
                        formik.touched.searchStrtDt &&
                        Boolean(formik.errors.searchStrtDt)
                      }
                      helperText={
                        formik.touched.searchStrtDt && formik.errors.searchStrtDt
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </Box>
            <Box sx={{ flex: { xs: 1, sm: '0 1 auto' }, minWidth: 0, width: { sm: 'auto' }, mx: { xs: 0, sm: 2 } }}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker
                  label="검색 종료일"
                  format="YYYY-MM-DD"
                  mask={'____-__-__'}
                  id="searchEndDt"
                  name="searchEndDt"
                  value={dayjs(searchEndDt)}
                  onChange={(newValue) => {
                    setSearchEndDt(dayjs(newValue));
                    onChangeDate(dayjs(newValue), 'searchEndDt');
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      fullWidth
                      error={
                        formik.touched.searchEndDt &&
                        Boolean(formik.errors.searchEndDt)
                      }
                      helperText={
                        formik.touched.searchEndDt && formik.errors.searchEndDt
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </Box>
          </Box>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              검색
            </Button>
          </Box>
        </Box>
        {/* <Box textAlign="center">
          <Button color="primary" variant="contained" onClick={handleAdd}>
            추가
          </Button>
        </Box> */}
      </Box>
    </div>
  );
};
